<button
  type="button"
  class="microsoft-button"
  [disabled]="disabled"
  (click)="onButtonClick()"
  data-testid="microsoft-button"
  [attr.aria-disabled]="disabled">
  <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="microsoft-icon">
    <g clip-path="url(#clip0_71_29802)">
      <path d="M7.01935 0.932739H1.28033V6.67176H7.01935V0.932739Z" fill="#F25022"/>
      <path d="M7.01935 7.30942H1.28033V13.0484H7.01935V7.30942Z" fill="#00A4EF"/>
      <path d="M13.396 0.932739H7.65698V6.67176H13.396V0.932739Z" fill="#7FBA00"/>
      <path d="M13.396 7.30942H7.65698V13.0484H13.396V7.30942Z" fill="#FFB900"/>
    </g>
    <defs>
      <clipPath id="clip0_71_29802">
        <rect width="13.391" height="13.391" fill="white" transform="translate(0.642639 0.295074)"/>
      </clipPath>
    </defs>
  </svg>
  <span class="button-text">{{ text }}</span>
</button>